import { fetcher } from "common/api/Fetcher";
import { ICustomerAuthOptions } from "common/api/image.service";

export type UploadType = "image" | "document";

export interface IDirectUploadResponse {
  urls: {
    id: string;
    url: string;
  }[];
}
const customer_url = "api/v1/jobs/:kind/direct_customer";

export const directUploadForCustomer = async (
  fileCount: number,
  uploadType: UploadType,
  options: ICustomerAuthOptions,
): Promise<IDirectUploadResponse> => {
  const actionUrl = fetcher.joinUrls(customer_url.replace(":kind", `${uploadType}s`), options.key);
  try {
    const response = await fetch(actionUrl, {
      body: JSON.stringify({ count: fileCount, token: options.token }),
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    });
    return await response.json();
  } catch (error: any) {
    return error.message;
  }
};
